import {Sky, Stats} from "drei";
import React, {Suspense, useEffect} from "react";
import {Canvas} from "react-three-fiber";
import {FogExp2} from "three";
import {Physics} from "use-cannon";
import useStore from "../../store";
import {getGpuTier} from "../../utils";
import CameraRaycaster from "./CameraRaycaster";
import Colliders from "./Colliders";
import Lights from "./Lights";
import Ltoz from "./LTOZv18";
import PlayerController from "./PlayerController";

function SceneFallback() {
  const sceneHasLoaded = useStore((state) => state.sceneHasLoaded);

  // We wait until the fallback is unmounted + 1 second to mark the scene as loaded
  useEffect(() => {
    return () => {
      setTimeout(() => {
        sceneHasLoaded();
      }, 1000);
    };
  }, [sceneHasLoaded]);

  return null;
}

function Scene() {
  const audioListener = useStore((state) => state.audioListener);
  const pixelRatio = getGpuTier() > 1 ? 1.5 : 1.25;

  return (
    <Canvas
      colorManagement
      shadowMap
      pixelRatio={pixelRatio}
      className="w-full h-full"
      onCreated={({camera, scene}) => {
        scene.fog = new FogExp2(0xcaf7ff, 0.005);

        camera.add(audioListener);
      }}
    >
      <Physics>
        <PlayerController
          height={1.7}
          // en la entrada del pueblo Torrevillage
          //startPos={[108, 1.7, 115]}
          startPos={[18, 1.7, 105]}
          // en la salida del pueblo Torrevillage
          // startPos={[18, 1.7, 115]}

          // mirando hacia la entrada, ligeramente contrapicado
          // startRot={[-0.3, 91.11, 0]}
          // mirando hacia la entrada, ligeramente picado
          startRot={[0.1, 91.11, 0]}
        />

        <Colliders />
      </Physics>

      <CameraRaycaster />

      <Lights />

      {/* @ts-ignore */}
      <Sky distance={4500000000} sunPosition={[-0.5, 1, -1]} />

      <Suspense fallback={<SceneFallback />}>
        <Ltoz />
      </Suspense>

      {/* <Stats /> */}
    </Canvas>
  );
}

export default Scene;
